<template>
    <BasePanel
        headline="lang_PUBLISHING_CAPTION_WORKS"
        :alvqa="alvqa"
        :onOpenPanel="onOpenPanel"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
                :page.sync="currentPage"
                :server-items-length="totalRecords"
                :loading="isLoading"
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <PublishingContractsWorksEditPanelTopSlot />
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
            <!-- <td 
							class="caption text-center"
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-status-type'">
							{{ getWorksType(item) }}
						</td>    type-->
                <template v-slot:[`item.type`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-title'">
                        {{ getWorksType(item) }}
                    </div>
                </template>
                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-title'">
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:[`item.workId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-work-id'">
                        {{ item.gemaNumber }}
                    </div>
                </template>
                <template v-slot:[`item.mainComposer`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.composers.join(' / ')"
                            :alvqa="alvqa + '-list-row-text-main-composer'"
                        />
                    </div>
                </template>
            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
            </v-data-table>
            <v-pagination   
                v-if="numberOfPages > 1"
                total-visible="10" 
                v-model="currentPage" 
                :length="numberOfPages"
                color="pagination"
                @input="nextPage()"
            ></v-pagination>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import PublishingContractsWorksEditPanelTopSlot from './PublishingContractsWorksEditPanelTopSlot'

export default {
    name: "PublishingContractsWorkEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon,
        BaseTooltip,
        PublishingContractsWorksEditPanelTopSlot
    },
    data() {
        return {
            alvqa: 'contracts-publishing-edit-form-panel-works'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: '', 
                    align: "left", 
                    value: "type",
                    class: 'text-no-wrap',
                    width: "80px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-type'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE"), 
                    align: "left", 
                    value: "title",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_WORK_ID"), 
                    align: "left", 
                    value: "workId",
                    class: 'text-no-wrap',
                    width: '150px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-work-id'
                },
                {
                    text: this.$t("lang_PUBLISHING_CAPTION_COMPOSERS"), 
                    align: "left", 
                    value: "mainComposer",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-main-composer'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },

        listItems() { return this.$store.getters.getPublishingContractsWorks },
        isLoading() { return this.$store.getters.getIsLoading },

        // Paging
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        numberOfPages() { return this.$store.getters.getNumberOfPages },
        totalRecords() { return this.$store.getters.getTotalRecords },
        currentPage: {
            get() { return this.$store.getters.getCurrentPage },
            set(page) { this.$store.commit('setCurrentPage', page)}
        },
    },
    methods: {
        async nextPage() { await this.$store.dispatch('fetchPublishingContractsWorks') },

        deleteRow(item) {
            this.$store.commit("setSelectedContractPublishingWork", item.alvId)
            this.$store.commit('setDeletionDialogContext', 'SelectedContractPublishingWork')
            this.$store.commit('setShowDeletionDialog', true)
        },
        onOpenPanel() {
            this.$store.dispatch('fetchPublishingContractsWorks')
        },
        getWorksType(item) {
			switch (item.type) {
				case 'opw':
					return this.$t("lang_PUBLISHING_WORKS_DROPDOWN_TYPE_OPW")
				case 'spw':
					return this.$t("lang_PUBLISHING_WORKS_DROPDOWN_TYPE_SPW")
				case 'upw':
					return this.$t("lang_PUBLISHING_WORKS_DROPDOWN_TYPE_UPW")
				default:
					return this.$t("lang_GENERAL_WORK")
			}
		},
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>